import { Order } from "@/store/orderStore";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { OrderCard } from "./OrderCard";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "@/hooks/use-mobile";
import { Badge } from "@/components/ui/badge";

export interface OrdersListProps {
  orders: Order[];
  onOrderClick?: (orderId: string) => void;
  isLoading?: boolean;
  storeId?: string;
}

export function OrdersList({
  orders,
  onOrderClick,
  isLoading = false,
  storeId,
}: OrdersListProps) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  if (isLoading) {
    return (
      <div className="space-y-3 sm:space-y-4 px-1 sm:px-0">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="animate-pulse">
            <CardHeader className="py-2 px-3 sm:px-4 sm:pb-2">
              <div className="h-5 sm:h-6 w-1/3 bg-muted rounded"></div>
              <div className="h-3 sm:h-4 w-1/4 bg-muted rounded mt-1"></div>
            </CardHeader>
            <CardContent className="py-2 px-3 sm:px-4">
              <div className="h-3 sm:h-4 w-3/4 bg-muted rounded mb-2"></div>
              <div className="h-3 sm:h-4 w-1/2 bg-muted rounded"></div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  if (orders.length === 0) {
    return (
      <div className="flex h-32 sm:h-40 items-center justify-center rounded-md border border-dashed mx-1 sm:mx-0">
        <p className="text-center text-muted-foreground text-sm sm:text-base">
          {t("noOrdersFound")}
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3 sm:space-y-4 px-1 sm:px-0">
      {orders.map((order) => (
        <OrderCard
          key={order.id}
          order={order}
          onClick={() => onOrderClick?.(order.id)}
          showPaymentStatus={true}
        />
      ))}
    </div>
  );
}
